import { render, staticRenderFns } from "./trainerAdd.vue?vue&type=template&id=1cfb27c6&scoped=true&"
import script from "./trainerAdd.vue?vue&type=script&lang=js&"
export * from "./trainerAdd.vue?vue&type=script&lang=js&"
import style0 from "./trainerAdd.vue?vue&type=style&index=0&id=1cfb27c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb27c6",
  null
  
)

export default component.exports